"use strict";

exports.__esModule = true;
exports.default = void 0;

var _visuallyHidden = _interopRequireDefault(require("../../../styles/mixins/visuallyHidden.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var css = "\n  " + (0, _visuallyHidden.default)() + "\n\n  &.is-focusable {\n    &:active,\n    &:focus {\n      clip: auto !important;\n      height: auto !important;\n      margin: 0;\n      overflow: visible !important;\n      position: static !important;\n      width: auto !important;\n    }\n  }\n";
var _default = css;
exports.default = _default;